<template>
  <div class="home">
    <div class="top">
      <!--<div class="message">
                <marquee scrollamount="2">{{ message }}</marquee>
            </div>-->
      <div class="header">
        <!--<div class="profile" @click="logOff">
                    <router-link to="/login"><img  src="/../assets/images/logout.png"/></router-link>
                </div>-->
        <!-- <div class="wallet">
                    <router-link to="/percentage"><img  src="/../assets/images/wallet.png" alt="钱包" title="钱包"/></router-link>
                </div> -->
        <div class="nickname">{{ user.uname }}</div>
        <div class="code">
          <!-- <span>{{  customerType }}</span> -->
        </div>
        <div class="userHandle">
          <span @click="mdfpsword">修改密码</span>
          <!-- <span class="line">|</span> -->
          <span @click="logOff"><router-link to="/login">退出登录</router-link></span>
        </div>
      </div>
      <div class="main">
        <div @click="goGains">
          <div class="gains-left">
            <h3 class="gains-title">累计收益</h3>
            <span
              class="gains"
              :style="{ marginTop: user.cashAmountCny > 0 || user.cashAmountUsd > 0 ? '0.2rem' : '0.8rem' }"
              ><span>￥</span>{{ user.totalAmountCny }} <br />
              <span>$ </span>{{ user.totalAmountUsd }}</span
            >
            <span class="withdraw" @click.stop="getWithdraw" v-if="user.cashAmountCny > 0 || user.cashAmountUsd > 0"
              >提现</span
            >
          </div>
        </div>
        <router-link to="/partners">
          <div class="partners-right">
            <h3 class="partners-title">我的成员</h3>
            <span class="partners">{{ user.totalUser }}</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="bottom">
      <div class="list">
        <ul id="message-list">
          <li v-for="item in items">
            <div class="zero">
              <span v-if="item.msgType == 0" class="default_bg"></span>
              <span v-if="item.msgType == 1" class="blue_bg"></span>
              <span v-else class="yellow_bg"></span>
            </div>
            <div class="second">
              <div class="content">{{ item.title }}</div>
              <div class="other">
                <span class="name">{{ item.subTitle }}</span>
                <span class="date">{{ item.ctime | date(4) }}</span>
              </div>
            </div>
          </li>
        </ul>
        <div v-if="end" class="endtext">------ 我是有底线的 ------</div>
        <div class="no-data" v-if="nodata">----- 暂无消息 -----</div>
        <div class="loadmore" v-if="allLoaded" @click="loadBottom">加载更多</div>
      </div>
    </div>
    <!-- <social-share></social-share> -->
    <!-- <div class="share">
      <div class="shareButton copy-url" :data-clipboard-text="shareUrl"  @click="openShare">
          <div class="shareImg"><img src="../assets/images/combined-shape.png"></div>
          <div class="line"></div>
          <div class="shareText">Invite Friends</div>
      </div>
    </div> -->

    <div class="share-button">
      <img
        class="copy-url"
        :data-clipboard-text="shareUrl"
        @click="shareToUser('zh')"
        src="../assets/images/share-button-zh.png"
      />
      <img
        class="copy-url"
        :data-clipboard-text="shareUrl"
        @click="shareToUser('en')"
        style="margin-left:5%;"
        src="../assets/images/share-button-en.png"
      />
    </div>

    <modify-password ref="mdfPassword"></modify-password>

    <van-popup style="width: 100%" position="bottom" v-model="shareShow" :overlay="true">
      <div class="share-box">
        <van-row>
          <!-- <van-col span="24">
            <a class="copy-url" :data-clipboard-text="shareUrl"  @click="openShare">
              <img src="../assets/images/activity/share-link.png">
              <span>Copy Link</span>
            </a>
          </van-col> -->
          <!-- <van-col v-if="isWeixin" span="12">
            <a @click="shareToFriend">
              <img src="../assets/images/activity/share-wechat.png" />
              <span>分享</span>
            </a>
          </van-col> -->
          <van-col span="12">
            <a class="copy-url" :data-clipboard-text="shareUrl" @click="openShare">
              <img src="../assets/images/activity/share-link.png" />
              <span>复制链接</span>
            </a>
          </van-col>
          <van-col v-if="!isWeixin" span="12">
            <a :href="emailUrl">
              <img src="../assets/images/activity/share-email.png" />
              <span>复制链接到邮箱</span>
            </a>
          </van-col>
        </van-row>
      </div>
    </van-popup>
    <!-- <van-overlay
      :show="shareShow"
      @click="shareShow = false"
    /> -->

    <div class="share-guide">
      <van-popup style="width: 100%" position="top" class="share-guide" v-model="shareGuide">
        <img @click="shareGuide = false" src="../assets/images/activity/share-guide.png" />
      </van-popup>
    </div>
    <!-- <van-overlay
      :show="shareGuide"
      @click="shareGuide = false"
    /> -->
  </div>
</template>

<script>
// import * as config from '../constant-config'
import ModifyPassword from '../components/ModifyPassword'
import Clipboard from 'clipboard'
import { Popup, Dialog, Row, Col, Toast } from 'vant'
import { wxShareConfig } from '../wx-config'
import PartnerApi from '../api/partner'
import storage from '../utils/storage'

export default {
  name: 'home',
  components: {
    ModifyPassword,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    [Row.name]: Row,
    [Col.name]: Col
  },
  data() {
    return {
      title: '贸易品控，轻松点点',
      desc: '手指一点，QC就到，只需99美金',
      url: '',
      imageUrl: '',
      // success: function () {
      //   MessageBox('消息', '分享成功')
      //   this.shareGuide = false
      // },
      // fail: function () {
      //   MessageBox('消息', '您取消了分享')
      //   this.shareGuide = false
      // },
      ifshow: true,
      message: '2018年12月31日前成单奖励分成2%',
      customerType: '单位合作方',
      currentPage: 1,
      pageSize: 10,
      allLoaded: false,
      bottomStatus: '',
      end: false,
      nodata: false,
      items: [
        {
          msgType: 0,
          title: '贸点点成单突破1000单',
          subTitle: 'tradeaider.com',
          ctime: '2016-12-11'
        }
      ],
      six: false,
      user: {},
      userToken: storage.getLocalStorage('user'),
      userinfo: {},
      shareUrl: '',
      emailUrl: '',
      shareShow: false,
      shareGuide: false,
      isWeixin: false,
      shareLang: 'zh'
    }
  },
  created: function() {
    this.getInfo()
  },
  mounted() {
    // 设置当前页微信分享参数
    this.weixinShare()
    // 判断微信
    let ua = window.navigator.userAgent.toLowerCase()
    this.isWeixin = ua.indexOf('micromessenger') > 0
    // 设置分享链接
    let userinfo = JSON.parse(window.localStorage.userinfo)
    this.userinfo = userinfo
    this.shareUrl = `http://club.tradeaider.com/activity/#/partner?bigshot_code=${this.userinfo.shareCode}&lang=cn`
    this.emailUrl = `mailto:?subject=【TradeAider】Presenting you with 4 discount coupons! Enjoy post-coupon quality control service for only 94 USD!&body=${
      this.shareUrl
    }`
  },
  methods: {
    getInfo() {
      let uid = this.userToken.uid
      PartnerApi.getUserInfo(uid).then(
        response => {
          let returnData = response.data
          let userinfo = returnData.data
          if (userinfo.userState === 2) {
            window.localStorage.clear()
            this.$router.replace('/login')
            Dialog.alert({
              message: '您的账户已经被锁定'
            }).then(() => {
              // on close
            })
          }
          if (returnData.success) {
            if (userinfo.userType === 2) {
              this.message = '2018年12月31日前成单奖励前5单25%，后续5%！'
              this.customerType = '贸点点员工'
            }
            window.localStorage.userinfo = JSON.stringify(userinfo)
            this.user = userinfo
            this.shareUrl = `http://club.tradeaider.com/activity/#/partner?bigshot_code=${
              this.userinfo.shareCode
            }&lang=en`
            this.emailUrl = `mailto:?subject=【TradeAider】Presenting you with 4 discount coupons! Enjoy post-coupon quality control service for only 94 USD!&body=${
              this.shareUrl
            }`
          }
        },
        response => {}
      )
      PartnerApi.getUserMsg(uid, this.currentPage).then(
        response => {
          let returnData = response.data
          let records = returnData.data.listItem
          if (returnData.success) {
            if (records.length === 0) {
              this.nodata = true
            }
            if (records.length <= this.pageSize && records.length > 0) {
              this.allLoaded = true
            } else {
              this.allLoaded = false
            }
            this.items = records
          }
        },
        response => {}
      )
    },
    goGains() {
      this.$router.push('/gains')
    },
    getWithdraw() {
      var that = this
      Dialog.alert({
        message: '确定全部提现？',
        title: `可提现金额：￥${this.user.cashAmountCny}/$${this.user.cashAmountUsd}`,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          // on close
          PartnerApi.WithdrawalApi(this.user.id).then(
            response => {
              let returnData = response.data
              if (returnData.success) {
                Toast({
                  message: returnData.msg,
                  className: 'toastClass'
                })
                that.getInfo()
              } else {
                Toast.fail(returnData.msg)
                that.getInfo()
              }
            },
            response => {}
          )
        })
        .catch(() => {
          // on cancel
        })
    },
    mdfpsword() {
      let mdfpassword = this.$refs.mdfPassword
      mdfpassword.isOpen = true
    },
    logOff() {
      window.localStorage.clear()
      this.$router.replace('/login')
    },
    handleBottomChange(status) {
      this.bottomStatus = status
    },
    loadBottom() {
      PartnerApi.getUserMsg(this.user.id, ++this.currentPage).then(
        response => {
          let returnData = response.data
          let records = returnData.data.listItem
          if (returnData.success) {
            if (records.length === 0) {
              this.allLoaded = false
              if (this.nodata === false) {
                this.end = true
              }
            } else {
              for (let i = 0; i < records.length; i++) {
                this.items.push(records[i])
              }
            }
          }
        },
        response => {}
      )
    },
    shareToLink() {
      // this.copy()
    },
    shareToUser(lang) {
      var that = this
      this.shareUrl =
        lang == 'en'
          ? `http://club.tradeaider.com/activity/#/partner?bigshot_code=${this.userinfo.shareCode}&lang=en`
          : `http://club.tradeaider.com/activity/#/partner?bigshot_code=${this.userinfo.shareCode}&lang=cn`
      this.emailUrl =
        lang == 'en'
          ? `mailto:?subject=【TradeAider】Presenting you with 4 discount coupons! Enjoy post-coupon quality control service for only 94 USD!&body=${
              this.shareUrl
            }`
          : `mailto:?subject=【贸点点】送您4张优惠券！券后品控服务只需519元！&body=${this.shareUrl}`
      let url = this.shareUrl
      this.shareLang = lang
      let imageUrl =
        lang == 'en'
          ? 'http://static.tradeaider.com/agreement/shot-1-en.png'
          : 'http://static.tradeaider.com/agreement/shot-1.png'
      let desc =
        lang == 'en'
          ? '【TradeAider】Presenting you with 4 discount coupons! Enjoy post-coupon quality control service for only 94 USD!'
          : '【贸点点】送您4张优惠券！券后品控服务只需519元！'
      // if (this.userinfo.shareCode === 'fo5akt' || this.userinfo.shareCode === 'wqoaaj' || this.userinfo.shareCode === '6o7c6z' || this.userinfo.shareCode === 'go23yz' || this.userinfo.shareCode === 'bod7cx' || this.userinfo.shareCode === 'hofwsh') {
      //   imageUrl = 'https://static.tradeaider.com/share-bigshot-six.png'
      //   desc = '领取贸点点官方授权VIP卡，享受3%的无限期优惠。'
      //   this.six = true
      // }
      let obj = {
        title: 'TradeAider VIP card for you！',
        desc: desc,
        link: url,
        imgUrl: imageUrl
      }
      this.shareShow = true
      wxShareConfig(obj, that.success, that.fail)
    },
    shareToFriend() {
      this.shareGuide = true
      this.shareShow = false
    },
    openShare() {
      this.copy()
      this.shareShow = false
      let msg = ''
      Dialog.alert({
        title: '温馨提示',
        message: '分享链接复制成功，快去分享给好友吧！',
        confirmButtonText: '确认'
      }).then(() => {
        // on close
      })
    },
    // 操作：复制通知链接
    copy() {
      // let userinfo = JSON.parse(window.localStorage.userinfo)
      var Url =
        this.shareLang == 'en'
          ? `【TradeAider】Presenting you with 4 discount coupons! Enjoy post-coupon quality control service for only 94 USD! ${
              this.shareUrl
            }`
          : `【贸点点】送您4张优惠券！券后品控服务只需519元！${this.shareUrl}`
      var clipboard = new Clipboard('.copy-url', {
        text: function() {
          return Url
        }
      })
      clipboard.on('success', e => {
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 释放内存
        clipboard.destroy()
      })
    },
    weixinShare() {
      // 合伙人当前页分享
      var that = this
      let url = 'http://club.tradeaider.com'
      let imageUrl = 'https://static.tradeaider.com/share-bigshot.png'
      let obj = {
        title: '合作伙伴',
        desc: '',
        link: url,
        imgUrl: imageUrl
      }
      wxShareConfig(obj, that.success, that.fail)
    },
    success() {
      this.shareGuide = false
    },
    fail() {}
  }
}
</script>

<style>
.toastClass {
  width: 10rem !important;
  word-break: break-word !important;
}
</style>
<style scoped>
.share-box {
  padding: 10% 0;
  text-align: center;
}
.share-box img {
  width: 30%;
  display: inline-block;
}
.share-box span {
  display: block;
  color: #999;
  padding-top: 5%;
  font-size: 14px;
}

.share-guide {
  background-color: transparent;
  text-align: center;
}
.share-guide img {
  padding-top: 5%;
  width: 80%;
}

.share-guide .van-popup {
  background-color: transparent;
  text-align: center;
}
.share-guide img {
  padding-top: 5%;
  width: 80%;
}

.share-button {
  text-align: center;
  position: fixed;
  bottom: 10px;
}

.share-button img {
  width: 40%;
  animation: mymove 3s infinite;
  -webkit-animation: mymove 3s infinite; /*Safari and Chrome*/
  animation-direction: alternate; /*轮流反向播放动画。*/
  animation-timing-function: ease-in-out; /*动画的速度曲线*/
  /* Safari 和 Chrome */
  -webkit-animation: mymove 3s infinite;
  -webkit-animation-direction: alternate; /*轮流反向播放动画。*/
  -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
}

.userHandle {
  padding-top: 10px;
}

.userHandle span {
  display: inline-block;
  width: 50%;
}

.userHandle span:first-child {
  border-right: 1px solid #fff;
}

@keyframes mymove {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.2); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.2);
  }
}

@-webkit-keyframes mymove /*Safari and Chrome*/ {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.2); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.2);
  }
}

@media (max-width: 750px) {
  .top {
    position: relative;
    height: 13.8333rem;
    box-sizing: border-box;
  }

  .header {
    height: 8.5333rem;
    background-image: url('../assets/images/header_blue.jpg');
    background-size: 100% 100%;
    text-align: center;
    box-sizing: border-box;
  }

  .userHandle {
    color: white;
    font-size: 0.56rem;
    margin-top: 0.3rem;
  }

  .userHandle span a {
    color: white;
  }

  .userHandle .line {
    margin: 0 0.2rem;
  }

  .profile {
    width: 1.0667rem;
    height: 1.0667rem;
    position: absolute;
    left: 0.4693rem;
    top: 1.8133rem;
  }

  .wallet {
    width: 1.0368rem;
    height: 0.9643rem;
    position: absolute;
    right: 0.6443rem;
    top: 1.3197rem;
  }

  .profile img,
  .wallet img {
    width: 100%;
    height: 100%;
  }

  .nickname {
    /*height: 1.4933rem;*/
    font-size: 1.0667rem;
    color: white;
    padding-top: 2.0387rem;
  }

  .code span {
    display: inline-block;
    width: 3.3707rem;
    height: 0.8107rem;
    font-size: 0.512rem;
    font-weight: 300;
    color: white;
    letter-spacing: 0.0107rem;
    line-height: 0.9107rem;
    border: 1px solid white;
    border-radius: 1.0667rem;
  }

  .home .main {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
  }

  .gains-left,
  .partners-right {
    width: 50%;
    height: 5.3rem;
    text-align: center;
  }
  .gains-left {
    float: left;
    background-color: rgba(0, 159, 233, 0.7);
  }

  .partners-right {
    float: right;
    background-color: rgba(248, 182, 44, 0.7);
  }

  .gains-title,
  .partners-title,
  .withdraw {
    margin-top: 0.84rem;
    font-size: 0.56rem;
    letter-spacing: 0.05rem;
    font-weight: normal;
    color: #ffffff;
    text-align: center;
  }

  .gains,
  .partners {
    display: block;
    margin-top: 1rem;
    height: 1.6rem;
    font-size: 1rem;
    font-weight: 300;
    line-height: 1;
    letter-spacing: 0.04rem;
    text-align: center;
    color: #ffffff;
  }
  .gains {
    margin-top: 0.2rem;
    margin-bottom: 0.3rem;
  }
  .withdraw {
    padding: 0.04rem 0.6rem;
    border: 0.01rem solid #fff;
    border-radius: 0.2rem;
    color: #fff;
  }
  .bottom ul li {
    display: block;
    height: 3.968rem;
    border-bottom: solid 0.0426rem rgba(0, 0, 0, 0.05);
    position: relative;
    overflow: hidden;
  }
  .bottom .zero {
    float: left;
    position: relative;
    width: 1.1946rem;
    height: 100%;
    border-right: solid 0.0426rem rgba(0, 0, 0, 0.05);
  }
  .bottom .zero span {
    display: block;
    width: 0.384rem;
    height: 0.384rem;
    border-radius: 50%;
    position: absolute;
    top: 1.792rem;
    right: -0.192rem;
  }
  .bottom .second {
    float: left;
    width: 14.8053rem;
    padding-left: 0.7893rem;
    padding-top: 1.0666rem;
  }
  .bottom .content {
    width: 100%;
    font-size: 0.5973rem;
  }
  .bottom .other {
    position: relative;
    width: 100%;
    font-size: 0.512rem;
    margin-top: 0.192rem;
  }
  .bottom .other .name {
    color: #1d1d26;
  }

  .bottom .other .date {
    position: absolute;
    top: 0;
    right: 0.9813rem;
    color: #9b9b9b;
  }

  .bottom img {
    vertical-align: middle;
    width: 1.6rem;
    height: 1.6rem;
    background-color: rgb(255, 255, 255);
    border: solid 1px rgb(199, 199, 199);
    border-radius: 50%;
  }
  .default_bg {
    width: 0.44rem;
    height: 0.44rem;
    background: url('../assets/images/default_bg.png') no-repeat;
    background-size: 0.44rem 0.44rem;
  }

  .bottom .zero .blue_bg {
    background-color: rgb(0, 160, 233);
  }

  .bottom .zero .yellow_bg {
    background-color: rgb(248, 182, 45);
  }

  .no-data,
  .endtext,
  .loadmore {
    font-size: 0.6rem;
    margin: 0.5rem 0;
    color: rgba(0, 0, 0, 0.4);
    text-align: center;
  }
  .v-modal {
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    opacity: 0.5;
    background: #000;
    z-index: 2004;
  }

  .shareButton {
    position: fixed;
    right: 0.84rem;
    bottom: 0.84rem;
    width: 5.1467rem;
    height: 1.5867rem;
    background: #f7a806;
    border-radius: 1.5rem;
    box-shadow: 0 0.12rem 0 0 #986702;
    box-sizing: border-box;
    padding-top: 0.256rem;
    padding-left: 0.512rem;
    overflow: hidden;
  }

  .shareButton div {
    float: left;
  }

  .line {
    border-right: 1px solid rgb(247, 190, 77);
    height: 0.9rem;
    margin-top: 0.15rem;
    margin-right: 0.2267rem;
  }

  .shareImg {
    width: 0.64rem;
    line-height: 0.9386rem;
    margin-right: 0.256rem;
    font-size: 0.512rem;
    padding-top: 0.2rem;
  }

  .shareImg img,
  .closeBox img {
    width: 100%;
    height: 100%;
  }

  .shareText {
    font-size: 0.512rem;
    font-weight: 300;
    color: white;
    padding-top: 0.204rem;
  }

  .share .weixin-sharetip {
    position: fixed;
    overflow: hidden;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6) url('../assets/images/weixin_sharetip.png') no-repeat right 0;
    background-size: 50% auto;
    z-index: 1000;
  }
}
@media (min-width: 750px) {
  .top {
    position: relative;
    height: 640px;
    box-sizing: border-box;
  }

  .header {
    height: 400px;
    background-image: url('../assets/images/header_blue.jpg');
    background-size: 100% 100%;
    text-align: center;
    box-sizing: border-box;
    font-size: 20px;
  }

  .userHandle {
    color: white;
    font-size: 26px;
    margin-top: 18px;
  }
  .userHandle span {
    cursor: pointer;
  }
  .userHandle span a {
    color: white;
  }

  .userHandle .line {
    margin: 0 2px;
  }

  .profile {
    width: 1.0667rem;
    height: 1.0667rem;
    position: absolute;
    left: 0.4693rem;
    top: 1.8133rem;
  }

  .wallet {
    width: 50px;
    height: 50px;
    position: absolute;
    right: 30px;
    top: 30px;
  }

  .profile img,
  .wallet img {
    width: 100%;
  }

  .nickname {
    font-size: 60px;
    color: white;
    padding-top: 119px;
  }
  .code {
    margin-top: 18px;
  }
  .code span {
    display: inline-block;
    width: 158px;
    height: 38px;
    font-size: 24px;
    font-weight: 300;
    color: white;
    letter-spacing: 1px;
    line-height: 38px;
    border: 1px solid white;
    border-radius: 50px;
  }

  /* .home .main{
        width: 100%;
        position: absolute;  
        left: 0; 
        bottom: 0;
    }*/

  .gains-left,
  .partners-right {
    width: 50%;
    height: 286px;
    text-align: center;
  }
  .gains-left {
    float: left;
    background-color: rgba(0, 159, 233, 0.7);
  }

  .partners-right {
    float: right;
    background-color: rgba(248, 182, 44, 0.7);
  }

  .gains-title,
  .partners-title {
    margin-top: 44px;
    font-size: 28px;
    letter-spacing: 2px;
    font-weight: normal;
    color: #ffffff;
    text-align: center;
  }

  .gains,
  .partners {
    display: block;
    margin-top: 38px;
    /* height: 80px; */
    font-size: 50px;
    font-weight: 300;
    line-height: 1;
    letter-spacing: 2px;
    text-align: center;
    color: #ffffff;
  }
  .bottom {
    background: #faf8fb;
  }
  .gains {
    margin-bottom: 20px;
  }
  .withdraw {
    padding: 0.12rem 0.9rem;
    border: 0.05rem solid #fff;
    border-radius: 0.2rem;
    color: #fff;
  }
  .bottom ul li {
    display: block;
    height: 186px;
    border-bottom: solid 2px rgba(0, 0, 0, 0.05);
    position: relative;
    overflow: hidden;
  }
  .bottom .zero {
    float: left;
    position: relative;
    width: 56px;
    height: 100%;
    border-right: solid 2px rgba(0, 0, 0, 0.05);
  }
  .bottom .zero span {
    display: block;
    width: 18px;
    height: 18px;
    border-radius: 9px;
    position: absolute;
    top: 84px;
    right: -9px;
  }
  .bottom .second {
    float: left;
    width: 694px;
    padding-left: 37px;
    padding-top: 50px;
  }
  .bottom .content {
    width: 100%;
    font-size: 28px;
  }
  .bottom .other {
    position: relative;
    width: 100%;
    font-size: 24px;
    margin-top: 9px;
  }
  .bottom .other .name {
    color: #1d1d26;
  }

  .bottom .other .date {
    position: absolute;
    top: 0;
    right: 45px;
    color: #9b9b9b;
  }
  .bottom img {
    vertical-align: middle;
    width: 1.6rem;
    height: 1.6rem;
    background-color: rgb(255, 255, 255);
    border: solid 1px rgb(199, 199, 199);
    border-radius: 50%;
  }

  /* .bottom .zero .default_bg{
        width: 0.44rem;
        height: 0.44rem;
        background: url('/../assets/images/default_bg.png') no-repeat;
        background-size: 0.44rem 0.44rem;
    } */

  .bottom .zero .blue_bg {
    background-color: rgb(0, 160, 233);
  }

  .bottom .zero .yellow_bg {
    background-color: rgb(248, 182, 45);
  }

  .no-data,
  .endtext,
  .loadmore {
    font-size: 20px;
    padding: 20px 0;
    color: rgba(0, 0, 0, 0.4);
    text-align: center;
  }
  .loadmore {
    cursor: pointer;
  }

  .share {
    width: 185px;
    height: 65px;
    position: fixed;
    bottom: 75px;
    left: 50%;
    margin-left: 195px;
  }
  .shareButton {
    position: absolute;
    right: -195px;
    bottom: 0px;
    width: 185px;
    height: 65px;
    background: #f7a806;
    border-radius: 35px;
    box-shadow: 0 6px 0 0 #986702;
    box-sizing: border-box;
    padding-left: 18px;
    overflow: hidden;
    cursor: pointer;
  }

  .shareButton div {
    float: left;
    height: 44px;
    margin-top: 11px;
  }

  .line {
    border-right: 1px solid rgb(247, 190, 77);
    height: 44px;
    margin-right: 10px;
  }

  .shareImg {
    width: 30px;
    line-height: 44px;
    margin-right: 12px;
    font-size: 24px;
    padding-top: 3px;
  }

  .shareImg img,
  .closeBox img {
    width: 100%;
  }

  .shareText {
    font-size: 24px;
    color: #fff;
    line-height: 44px;
  }

  .share .weixin-sharetip {
    position: fixed;
    overflow: hidden;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6) url('../assets/images/weixin_sharetip.png') no-repeat right 0;
    background-size: 50% auto;
    z-index: 1000;
  }

  .share-button {
    width: 600px;
    left: 0;
    right: 0;
    margin: auto;
  }
}
</style>
